class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  // Define updateShippingProgress as a method inside the class
  updateShippingProgress() {
    const subtotalElement = document.getElementById('js-cart-subtotal');
    // console.log(subtotalElement);

    if (!subtotalElement) return;

    const shippingAwayElement = document.getElementById('shipping-away');
    const progressElement = document.getElementById('shipping-progress');
    const rawSubtotal = subtotalElement.textContent;
    const subtotal = parseFloat(rawSubtotal.replace(/[^\d.-]/g, ''));
    const freeShippingValue = shippingAwayElement.closest('.cart-drawer__shipping').dataset.price; // Adjust as needed
    const freeShippingThreshold = parseFloat(freeShippingValue.replace(/[^\d.-]/g, ''));
    // const freeShippingThreshold = shippingAwayElement.closest('cart-drawer__shipping').dataset.price; // Adjust as needed

    if (subtotal < freeShippingThreshold) {
      const amountAway = (freeShippingThreshold - subtotal).toFixed(2);
      const progress = (subtotal / freeShippingThreshold) * 100;

      shippingAwayElement.textContent = `$${amountAway} away`;
      progressElement.style.setProperty('--progress', `${progress}%`);
    } else {
      shippingAwayElement.textContent = `Free shipping achieved!`;
      progressElement.style.setProperty('--progress', '100%');
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      const productSelector = document.querySelectorAll('.js-product-calc');
      if (productSelector.length > 0) {
        productSelector.forEach((product) => {
          const cardBottomHeight = product.querySelector('.card__bottom');
          const cardTopHeight = product.querySelector('.card__top');
          const cardInnerHeight = product.querySelector('.card__inner');
          const cardContentHeight = product.querySelector('.card__content--height');
          const cardHeight =
            cardBottomHeight.clientHeight +
            cardTopHeight.clientHeight +
            cardInnerHeight.clientHeight +
            cardContentHeight.clientHeight +
            'px';
          product.style.setProperty('--bottom-height', cardHeight);
        });
      }
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    this.updateShippingProgress();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
